import Selectize from "selectize";
import $ from "jquery";

Selectize.define("remove_button_a11y", function (options) {
  options = $.extend(
    {
      label: "",
      title: "Remove",
      className: "icon-times-light",
      append: true
    },
    options
  );

  var KEY_RETURN = 13;
  var KEY_SPACE = 32;

  /**
   * Renders the remove button on single selection
   * @param thisRef
   * @param options
   */
  var singleClose = function (thisRef, options) {
    options.className = "remove-single";

    var self = thisRef;

    /**
     * Appends an element as a child (with raw HTML).
     *
     * @param {string} html_container
     * @param {string} html_element
     * @return {string}
     */
    var append = function (html_container, html_element) {
      return $("<span>").append(html_container).append(html_element);
    };

    /**
     * Clears the selected item
     * @param {Event} e
     */
    var clearSelection = function (e) {
      e.preventDefault();
      if (self.isLocked) {
        return;
      }
      self.clear();
    };

    /**
     * Override the setup to render the remove button on the selected item
     * @type {function(): void}
     */
    thisRef.setup = (function () {
      var original = self.setup;
      return function () {
        // Override the item render method to add the remove button
        if (options.append) {
          var render_item = self.settings.render.item;
          self.settings.render.item = function (data) {
            return append(
              render_item.apply(thisRef, arguments),
              removeBtnHtml(data.text, options)
            );
          };
        }

        // Add mouse click event listener
        original.apply(thisRef, arguments);

        // Add event listener
        thisRef.$control.on("click", "." + options.className, function (e) {
          clearSelection(e);
        });

        // Add key enter and space event listener
        thisRef.$control.on("keyup", "." + options.className, function (e) {
          if (
            e.keyCode &&
            (e.keyCode === KEY_RETURN || e.keyCode === KEY_SPACE)
          ) {
            clearSelection(e);
          }
        });
      };
    })();
  };

  /**
   * Renders the remove button on multiple select
   * @param thisRef
   * @param options
   */
  var multiClose = function (thisRef, options) {
    var self = thisRef;

    /**
     * Appends an element as a child (with raw HTML).
     *
     * @param {string} html_container
     * @param {string} html_element
     * @return {string}
     */
    var append = function (html_container, html_element) {
      var pos = html_container.search(/(<\/[^>]+>\s*)$/);
      return (
        html_container.substring(0, pos) +
        html_element +
        html_container.substring(pos)
      );
    };

    /**
     * Remove the selected item
     * @param {Event} e
     */
    var removeSelection = function (e) {
      e.preventDefault();
      if (self.isLocked) return;

      var $item = $(e.currentTarget).parent();
      self.setActiveItem($item);
      if (self.deleteSelection()) {
        self.setCaret(self.items.length);
      }
    };

    /**
     * Override the setup to render the remove button on the selected item
     * @type {function(): void}
     */
    thisRef.setup = (function () {
      var original = self.setup;
      return function () {
        if (options.append) {
          var render_item = self.settings.render.item;
          self.settings.render.item = function (data) {
            return append(
              render_item.apply(thisRef, arguments),
              removeBtnHtml(data.text, options)
            );
          };
        }

        original.apply(thisRef, arguments);

        // Add mouse click event listener
        thisRef.$control.on("click", "." + options.className, function (e) {
          removeSelection(e);
        });

        // Add key enter and space event listener
        thisRef.$control.on("keyup", "." + options.className, function (e) {
          if (
            e.keyCode &&
            (e.keyCode === KEY_RETURN || e.keyCode === KEY_SPACE)
          ) {
            removeSelection(e);
          }
        });
      };
    })();
  };

  if (this.settings.mode === "single") {
    singleClose(this, options);
  } else {
    multiClose(this, options);
  }

  function removeBtnHtml(title, options) {
    return (
      '<a role="button" class="' +
      options.className +
      '" tabindex="0" aria-label="' +
      options.title +
      " " +
      title +
      '">' +
      options.label +
      "</a>"
    );
  }
});
